import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { DvirReportState } from '../types';
import { dvirReportsState } from './dvirReportState';
import { Reports } from 'app/types/reports';

export const dvirReportsSlice = createSlice({
  name: 'dvirReports',
  initialState: dvirReportsState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setReports(state, action: PayloadAction<Reports[]>) {
      state.reports = action.payload;
    },
    setDataRetentionDvir(
      state,
      action: PayloadAction<DvirReportState['dataRetentionDvir']>,
    ) {
      state.dataRetentionDvir = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: dvirReportsActions } = dvirReportsSlice;

/* ------- STATE SELECTORS ------- */
export const selectDvirReports = (state: RootState) => state.dvirReports;

export default dvirReportsSlice.reducer;
